import { Dashboard } from '../context/DashboardsProvider/types';

export const getSelectedDashboard = (
	dashboards: Dashboard[],
	dashboardId: string
) => {
	if (!Array.isArray(dashboards)) return undefined;

	return dashboards.find(
		(d) => d?.report?.id?.toString() === dashboardId?.toString()
	);
};
